import { isFlexContainer } from "./is-flex-container.js";
/**
 * {@link https://drafts.csswg.org/css-flexbox-1/#flex-items}
 *
 * @internal
 */
export function isFlexItem(style) {
    return isFlexContainer(style.parent);
}
//# sourceMappingURL=is-flex-item.js.map